import { Injectable } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { selectAllSites, selectSitesBySiteId, selectSitesByCompanyId, selectSitesByCompanyIdAndBranchManager, selectSitesByCompanyIdAndGroupId, selectSitesByCompanyIdAndBranchManager3, selectSitesByCompanyIdAndSiteId } from './store/reducers';
import { UUID } from 'angular2-uuid';
import * as SiteActions from './store/actions/sites.actions';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/compat/firestore';
import { Site } from '../models/sites.model';
import { StringOrNumberOrDate } from '@swimlane/ngx-charts';

@Injectable({
  providedIn: 'root'
})
export class SitesService {
  messages$: any;
  public siteChangeRef = new BehaviorSubject<any>([]);

  constructor(
    private store: Store<any>,
    protected db: AngularFirestore,
  ) {

    const preSites = [
      '1st message',
      '2nd message',
      '3rd message',
      '4th message',
      '5th message'
    ];

    // this.messages$ = this.site.select(selectAllSites);

    // for (let i = 0; i < preSites.length; i++) {
    //   this.addSite(preSites[i]);
    // }

    // this.getSites();

    this.siteChangeRef
      .subscribe((site) => {

        console.log("this.selectedSite", site)

      });
  }


  public changeSite(site: Site, ngTemplateRqd: number) {
    const message = {
      site: site,
      ngTemplateRqd: ngTemplateRqd
    }
    this.siteChangeRef.next(message);
  }

  addSiteFirebase$(site: Site): any {
    return this.db.collection('sites').add(site);
  }

  addSite(value: any): void {
    const site: Site = {
      companyId: value.companyId,
      siteName: value.siteName,
      contactName: value.contactName,
      contactTitle: value.contactTitle,
      email: value.email,
      address: value.address,
      city: value.city,
      region: value.region,
      postalCode: value.postalCode,
      country: value.country,
      phone: value.phone,
      // id: this.generateUUID(),
      startDate: new Date(),
      groupId: value.groupId,
      userId: value.userId,
      lat: value.lat,
      lon: value.lon,
      payg: value.payg,
      webFooterText: value.webFooterText,
      strapLineText: value.strapLineText,
      secret: value.secret,
      subscriptionEndDate: value.subscriptionEndDate,
      applicationStatus: value.applicationStatus,
      discount: value.discount,
      dogF: value.dogF,
      cashCurrency: value.cashCurrency,
      priceByDistance: value.priceByDistance,
      siteDeliveryType: value.siteDeliveryType
    };
    this.store.dispatch(new SiteActions.AddSite(site));

  }

  deleteSite(id: any): void {
    this.store.dispatch(new SiteActions.DeleteSite(id));
  }

  destroySite(id: string): void {
    this.store.dispatch(new SiteActions.DestroySite(id));
  }

  destroySiteFirebase$(id: string): any {
    return this.db.collection('sites').doc(id).delete();
  }
  updateSite(site: any): void {
    // message.dateResolved = new Date();
    this.store.dispatch(
      new SiteActions.UpdateSite(site)
    );

  }

  updateSiteFirebase$(site: any): any {
    console.log('updateSite$: e', site);

    const productsRef: AngularFirestoreDocument<any> = this.db.collection('sites').doc(site.id);
    site.file = null;
    const siteData: any = Object.assign({}, site);

    return of(productsRef.set(siteData, { merge: true }));
  }

  getSites(): void {
    this.store.dispatch(new SiteActions.FetchSites());
  }

  getSites$(): Observable<any> {

    const sitesCollection = this.db.collection<Site>('sites', ref => ref
      // .orderBy('id', 'asc')
    );

    console.log('sitesCollection=======', sitesCollection);

    return sitesCollection.snapshotChanges()
      .pipe(
        map(actions => {
          return actions.map(a => {
            const data = a.payload.doc.data() as any;
            const id = a.payload.doc.id;
            return { id, ...data };
          });
        })
      );
  }

  getSitesByCompanyId(companyId: any): void {
    this.store.dispatch(new SiteActions.FetchSitesByCompanyId(companyId));
  }

  getSitesByCompanyIdSiteId(companyId: any, siteId: any): void {
    this.store.dispatch(new SiteActions.FetchSitesByCompanyIdSiteId(companyId, siteId));
  }

  getSitesByCompanyId$(id: String, limit?: number): Observable<any> {

    if (id === null) { return of([]) }

    let sitesCollection;

    if (limit !== null) {
      sitesCollection = this.db.collection<any>('sites', ref => ref
        .where('companyId', '==', id)
        .limit(limit!)
      );
    } else {
      sitesCollection = this.db.collection<any>('sites', ref => ref
        .where('companyId', '==', id)
      );
    }

    return sitesCollection.snapshotChanges()
      .pipe(
        map(actions => {
          return actions.map(a => {
            const data = a.payload.doc.data() as any;
            const theId = a.payload.doc.id;
            return { id: theId, ...data };
          });
        })
      );
  }

  getLimitedSitesByCompanyId$(id: StringOrNumberOrDate, limit: number): Observable<any> {

    if (id === null) { return of([]) }

    const sitesCollection = this.db.collection<any>('sites', ref => ref
      .where('companyId', '==', id)
      .limit(limit)
    );

    return sitesCollection.snapshotChanges()
      .pipe(
        map(actions => {
          return actions.map(a => {
            const data = a.payload.doc.data() as any;
            const theId = a.payload.doc.id;
            return { id: theId, ...data };
          });
        })
      );
  }

  getSitesByCompanyIdSiteId$(companyId: string, siteId: string): Observable<any> {

    // I dont know why the filter in the collection does not work on id as it does with other
    // fields. So i have a filter on the snapshotchanges. Lost good day on this.
    // tap is just for my sanity on looping the collection.

    const sitesCollection = this.db.collection<any>('sites', ref => ref
      .where('companyId', '==', companyId)
      // .where('id', '==', 'ITmT5Xk22Bwyf1mufHK2')
      .orderBy('startDate', 'desc')
    );

    return sitesCollection.snapshotChanges()
      .pipe(
        map(snaps => snaps.filter(snap => snap.payload.doc.id === siteId)),
        map(actions => {
          return actions.map(a => {
            const data = a.payload.doc.data() as any;
            const theId = a.payload.doc.id;
            return { id: theId, ...data };
          });
        })
      );
  }

  findsites(companyId: any): Observable<Site[]> {
    return this.store.pipe(
      select(selectAllSites),
      map((sites: any[]) => sites.filter((site: any) => site.companyId === companyId)),
    );
  }

  findSitesByCompanyId(id: string): Observable<Site[]> {

    return this.store.select(selectSitesByCompanyId, { id });

  }

  findSitesByCompanyIdAndBranchManager2(id: string, branchManagerEmail: string): Observable<Site[]> {

    return this.store.select(selectSitesByCompanyId, { id });

  }

  findSitesByCompanyIdAndBranchManager(id: string, branchManagerEmail: string): Observable<Site[]> {

    // return this.store.pipe(
    //   select(selectSitesByCompanyIdAndBranchManager),
    // );
    return this.store.select(selectSitesByCompanyIdAndBranchManager, { id, branchManagerEmail });

  }

  findSitesByCompanyIdAndBranchManager3(id: string, branchManagerUserId: string): Observable<Site[]> {
    return this.store.select(selectSitesByCompanyIdAndBranchManager3, { id, branchManagerUserId });
  }

  findSitesByCompanyIdAndGroupId(companyId: string, groupId: string): Observable<Site[]> {

    // Get site coverage for area manager
    return this.store.select(selectSitesByCompanyIdAndGroupId, { companyId, groupId });

  }



  findSitesBySiteId(siteId: string): Observable<Site[]> {

    return this.store.pipe(
      select(selectSitesBySiteId, { siteId }),
      // map((companies: Company[]) => companies.filter((company: Company) => company.id === this.companyId)),
    );


  }

  findSiteByCompanyIdSiteId(companyId: string, siteId: string): Observable<Site[]> {
    return this.store.select(selectSitesByCompanyIdAndSiteId, { companyId, siteId });
  }
  generateUUID(): string {
    return UUID.UUID();
  }
}
